$(document).ready(function(){
    var pageTitle = $('.page-title');
    if (pageTitle.length){
        var pageTitleImg = pageTitle.attr('data-img');
        pageTitle.parallax({
            imageSrc: pageTitleImg });
    }
});

function titleParallaxEffect(){
    var wS = $(window).scrollTop(),
        title = $('.page-title').find('span');
    
        titleOffset = wS/2;

        title.css('transform', 'translateY(' + titleOffset + 'px)');
};

$(window).on('load scroll', function(){
    titleParallaxEffect();
});

